export default {
  appName: 'glasson-suggestion'
}